import React from 'react';
import { KeyRound } from 'lucide-react';

import { extractCredentialSetupFromToolResult } from './credentialSetupFromToolResult';
import { useOptionalAgentPanel } from '../AgentPanelContext';

const CredentialSetupContinueCard = ({ toolName, toolResult }) => {
  const chat = useOptionalAgentPanel();
  const action = extractCredentialSetupFromToolResult(toolName, toolResult);
  if (!chat?.openCredentialSetup || !action) return null;

  return (
    <div className="ml-7 mb-1 mt-1">
      <button
        type="button"
        onClick={() => chat.openCredentialSetup(action)}
        className="inline-flex items-center gap-1.5 rounded-md border border-emerald-200 bg-emerald-50 px-2.5 py-1.5 text-xs font-medium text-emerald-950 hover:bg-emerald-100"
      >
        <KeyRound size={13} aria-hidden="true" />
        Continue credential setup
      </button>
    </div>
  );
};

export default CredentialSetupContinueCard;
